import React, { useEffect, useMemo } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

const sortAlphabetically = (items = []) =>
  [...items].sort((a, b) =>
    String(a?.name || "").localeCompare(String(b?.name || ""), "es", {
      sensitivity: "base",
      numeric: true,
    })
  );

const FilterProduct = ({
  search,
  setSearch,
  sectionFilter,
  setSectionFilter,
  categoryFilter,
  setCategoryFilter,
  brandFilter,
  setBrandFilter,
  sections = [],
  categories = [],
  brands = [],
  onClear,
}) => {
  useEffect(() => {
    setCategoryFilter("TODAS");
  }, [sectionFilter, setCategoryFilter]);

  const sortedSections = useMemo(() => sortAlphabetically(sections), [sections]);
  const sortedCategories = useMemo(() => sortAlphabetically(categories), [categories]);
  const sortedBrands = useMemo(() => sortAlphabetically(brands), [brands]);

  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            lg: "repeat(4, minmax(0, 1fr))",
          },
          gap: 2,
          mb: 2,
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: 700, color: "#424242", mb: 0.8 }}>
            Sección
          </Typography>

          <TextField
            select
            fullWidth
            value={sectionFilter}
            onChange={(e) => setSectionFilter(e.target.value)}
          >
            <MenuItem value="TODAS">Todas</MenuItem>
            {sortedSections.map((section) => (
              <MenuItem key={section.id} value={section.id}>
                {section.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box>
          <Typography sx={{ fontWeight: 700, color: "#424242", mb: 0.8 }}>
            Categoría
          </Typography>

          <TextField
            select
            fullWidth
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
            <MenuItem value="TODAS">Todas</MenuItem>
            {sortedCategories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box>
          <Typography sx={{ fontWeight: 700, color: "#424242", mb: 0.8 }}>
            Marca
          </Typography>

          <TextField
            select
            fullWidth
            value={brandFilter}
            onChange={(e) => setBrandFilter(e.target.value)}
          >
            <MenuItem value="TODAS">Todas</MenuItem>
            {sortedBrands.map((brand) => (
              <MenuItem key={brand.id} value={brand.id}>
                {brand.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>

      </Box>

      <TextField
        fullWidth
        placeholder="Buscar por código, nombre, código de barras, categoría o marca"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default FilterProduct;